import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const createRate: UseCase<RateRepository, 'createRate'> = repository => {
  return async (payload) => {
    return await repository.createRate(payload)
  }
}
